import {
    getSearchFiltersApiConfig, getSearchHotContentsApiConfig,
    getSearchRecommendationsApiConfig, getSearchResultsApiConfig
} from '@/constants/ApiUrls';
import requestMethods from '@/helpers/request/requestMethods';
import { SearchRecommendationRespType } from '@/app/search/models/recommendations';
import { SearchFiltersRespType } from '@/app/search/models/filters';
import { SearchHotContentsRespType } from '@/app/search/models/hots';
import { SearchResultsRespType } from '@/app/search/models/results';

export function getSearchRecommendations(searchQueryParams): Promise<SearchRecommendationRespType> {
    return requestMethods.get({
        routeConfig: {
            ...getSearchRecommendationsApiConfig,
            url: `${getSearchRecommendationsApiConfig.url}${searchQueryParams ? ('?' + searchQueryParams) : ''}`
        }
    });
}

export function getSearchFilters(babyMode: boolean): Promise<SearchFiltersRespType> {
    return requestMethods.get({
        routeConfig: getSearchFiltersApiConfig,
        config: {
            params: {
                age_level: babyMode ? 'babies' : 'kids'
            }
        }
    });
}

export function getSearchHotContents(): Promise<SearchHotContentsRespType> {
    return requestMethods.get({
        routeConfig: getSearchHotContentsApiConfig
    });
}

export function getSearchResults(searchQueryParams, offset, pageSize): Promise<SearchResultsRespType> {
    return requestMethods.get({
        routeConfig: {
            ...getSearchResultsApiConfig,
            url: `${getSearchResultsApiConfig.url}${'?' + `offset=${offset}&size=${pageSize}`}${searchQueryParams ? ('&' + searchQueryParams) : ''}`
        }
    });
}